<template>
  <div>
    <Head title="Validated Invoices" />
    <h1 class="mb-8 text-3xl font-bold">Invoice Validation Process</h1>
    <div class="mb-3">
      <Link href="/invoices" class="text-orange-600 hover:text-orange-500 mb-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          stroke-width="1.5"
          stroke="currentColor"
          class="w-6 h-6 inline"
          style="display: inline !important"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M10.5 19.5L3 12m0 0l7.5-7.5M3 12h18"
          />
        </svg>
        View Invoices
      </Link>
    </div>
    <div
      class="relative py-3 pl-4 pr-10 leading-normal text-red-700 bg-green-100 rounded-lg"
      role="alert"
    >
      <p>
        Please keep refreshing this page to view the most current validation statuses.
      </p>
      <span class="absolute inset-y-0 right-0 flex items-center mr-4">
        <svg class="w-4 h-4 fill-current" role="button" viewBox="0 0 20 20">
          <path
            d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
            clip-rule="evenodd"
            fill-rule="evenodd"
          ></path>
        </svg>
      </span>
    </div>
    <hr />

    <div class="bg-white rounded-md shadow overflow-x-auto mt-5">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3 border border-dark">Invoice Date</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Invoice Number</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Order Number</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Customer</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Amount</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Loaded By</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Validated By</th>
          <th class="pb-3 pt-3 px-3 border border-dark">Validation Status</th>
        </tr>
        <tr
          v-for="listp in invoices.data"
          :key="listp.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t border border-dark">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.date }}
            </span>
          </td>
          <td class="border-t border border-dark">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.invoice_number }}
            </span>
          </td>
          <td class="border-t border border-dark">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.order_number }}
            </span>
          </td>
          <td class="border-t border border-dark">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.customer_name }}
            </span>
          </td>
          <td class="border-t border border-dark">
            <span
              class="flex items-center px-3 py-3 focus:text-orange-500 items-end px-3 items-end justify-end"
            >
              {{ listp.amount }}
            </span>
          </td>
          <td class="border-t border border-dark">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.loaded_by }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.validated_by }}
            </span>
          </td>
          <td class="border-t">
            <span class="flex items-center px-3 py-3 focus:text-orange-500">
              {{ listp.validated_status }}
            </span>
          </td>
        </tr>
        <tr v-if="invoices.data.length === 0">
          <td class="px-3 py-3 border-t border border-dark" colspan="7">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="invoices.links" />
  </div>
</template>
<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import Icon from "@/Shared/Icon";
import SearchWithDateRange from "@/Shared/SearchWithDateRange";
import DateRange from "@/Shared/DateRange";
import pickBy from "lodash/pickBy";
import mapValues from "lodash/mapValues";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import Pagination from "@/Shared/Pagination";

export default {
  components: {
    Head,
    Icon,
    Link,
    SearchWithDateRange,
    DateRange,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    invoices: Object,
  },
  data() {
    return {};
  },
  computed: {
    role() {
      return this.$inertia.page.props.auth.user.role;
    },
  },
  watch: {},
  methods: {},
};
</script>
